import { render } from "./SupportAccordion.vue?vue&type=template&id=9489cae4&scoped=true"
import script from "./SupportAccordion.vue?vue&type=script&lang=js"
export * from "./SupportAccordion.vue?vue&type=script&lang=js"

import "./SupportAccordion.vue?vue&type=style&index=0&id=9489cae4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9489cae4"

export default script